import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust according to your Firebase setup
import './styles/ManageStatDom.css';
import NavbarAdmin from '../components/NavbarAdmin';

const ManageStatGenre = () => {
  const [statistics, setStatistics] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    hommes: '',
    femmes: '',
    annee: ''
  });

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'statistics_genre'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStatistics(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchStatistics();
  }, []);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, 'statistics_genre', editId);
      await updateDoc(docRef, {
        ...editData,
        hommes: parseFloat(editData.hommes) || 0,
        femmes: parseFloat(editData.femmes) || 0,
      });
      alert("Document updated successfully!");
      setEditId(null);
      setEditData({
        hommes: '',
        femmes: '',
        annee: ''
      });
      // Refetch data to update the table
      const querySnapshot = await getDocs(collection(db, 'statistics_genre'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setStatistics(data);
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer cet élément ?");
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, 'statistics_genre', id));
        alert("Document supprimé avec succès !");
        // Refetch data to update the table
        const querySnapshot = await getDocs(collection(db, 'statistics_genre'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStatistics(data);
      } catch (error) {
        console.error("Erreur lors de la suppression du document : ", error);
      }
    }
  };

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear - 5; year <= currentYear + 5; year++) {
    years.push(year);
  }

  const headingStyle = {
    fontSize: '2rem', 
    color: '#cc6699',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px'
  };
  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const formStyle = {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    maxWidth: '600px',
    margin: '0 auto',
  };
  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
        <h2 style={headingStyle}>Gérer les Statistiques par genre</h2>
        <table>
          <thead>
            <tr>
              <th>Année</th>
              <th>Hommes</th>
              <th>Femmes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {statistics.map(stat => (
              <tr key={stat.id}>
                <td className="annee">{stat.annee}</td>
                <td>{stat.hommes}</td>
                <td>{stat.femmes}</td>
                <td>
                  <button className="modifier" onClick={() => {
                    setEditId(stat.id);
                    setEditData({
                      hommes: stat.hommes,
                      femmes: stat.femmes,
                      annee: stat.annee
                    });
                  }}>Modifier</button>
                  <span> </span>
                  <button className="supprimer" onClick={() => handleDelete(stat.id)}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {editId && (
          <form onSubmit={handleEditSubmit} style={formStyle}>
           <h3 style={{ color: '#6699CC' }}>Modifier les Statistiques par genre</h3>
            <label>Année:
              <select name="annee" value={editData.annee} onChange={handleEditChange} style={inputStyle} required>
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </label><br />
            <label>Hommes:
              <input type="number" name="hommes" value={editData.hommes} onChange={handleEditChange}  style={inputStyle} required />
            </label><br />
            <label>Femmes:
              <input type="number" name="femmes" value={editData.femmes} onChange={handleEditChange} style={inputStyle} required />
            </label><br />
            <button type="submit" style={buttonStyle}>Mettre à jour</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ManageStatGenre;
